// Maps API entity types to URL-friendly slugs (and back)
const SLUG_MAP: Record<string, string> = {
  site_of_care: 'site-of-care',
};

const SLUG_TO_TYPE_MAP: Record<string, string> = Object.fromEntries(
  Object.entries(SLUG_MAP).map(([type, slug]) => [slug, type])
);

export function profileTypeToSlug(type: string): string {
  return SLUG_MAP[type] ?? type;
}

export function slugToProfileType(slug: string): string {
  return SLUG_TO_TYPE_MAP[slug] ?? slug;
}

export function getProfileUrl(
  type: string,
  id: string | number,
  subpath?: string
): string {
  const slug = profileTypeToSlug(type);
  return subpath
    ? `/profiles/${slug}/${id}/${subpath}`
    : `/profiles/${slug}/${id}`;
}
